import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { Module } from '@/modules/companies'
import { ALL_DYNAMIC_COLUMNS_QUERY } from '@/modules/dynamic_tables'
import type {
  AllDynamicColumnsQuery,
  AllDynamicColumnsQueryVariables,
  ColumnNames,
} from '@/modules/dynamic_tables'
import { useOnErrorAuto } from '@/utils/hooks'

export interface SalaryApproveColumns {
  isEnabled: (name: ColumnNames) => boolean
  getDisplayName: (name: ColumnNames) => string | undefined
}

export const useSalaryApproveColumns = (): SalaryApproveColumns => {
  const onErrorAuto = useOnErrorAuto()

  const { data } = useQuery<
    AllDynamicColumnsQuery,
    AllDynamicColumnsQueryVariables
  >(ALL_DYNAMIC_COLUMNS_QUERY, {
    variables: {
      moduleName: Module.SALARY,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    onError: onErrorAuto(),
  })

  const columnsByName = useMemo(() => {
    const nodes = data?.allDynamicColumns.edges.map(edge => edge.node) ?? []
    return new Map(nodes.map(c => [c.name, c]))
  }, [data])

  return {
    isEnabled: (name: ColumnNames) =>
      columnsByName.get(name)?.enabled ?? false,
    getDisplayName: (name: ColumnNames) =>
      columnsByName.get(name)?.displayName,
  }
}
